export default "__VITE_ASSET__BqnruFtK__"